import { DTODocumentationItemConfigurationV2 } from "./item-configuration-v2";
import { z } from "zod";
export const DTODocumentationDraftChangeType = z.enum([
    "Created",
    "Updated",
    "Deleted",
]);
export const DTODocumentationDraftStateCreated = z.object({
    changeType: z.literal(DTODocumentationDraftChangeType.enum.Created),
});
export const DTODocumentationDraftStateUpdated = z.object({
    changeType: z.literal(DTODocumentationDraftChangeType.enum.Updated),
    changes: z.object({
        previousTitle: z.string().optional(),
        previousConfiguration: DTODocumentationItemConfigurationV2.optional(),
        previousContentHash: z.string().optional(),
    }),
});
export const DTODocumentationDraftStateDeleted = z.object({
    changeType: z.literal(DTODocumentationDraftChangeType.enum.Deleted),
    deletedAt: z.coerce.date(),
    deletedByUserId: z.string(),
});
export const DTODocumentationDraftState = z.discriminatedUnion("changeType", [
    DTODocumentationDraftStateCreated,
    DTODocumentationDraftStateUpdated,
    DTODocumentationDraftStateDeleted,
]);
